import { z } from "zod";

import { DatabaseIdentity } from "@/core/api";
import { DateIsoString } from "@/core/types";
import { JobRequestClient } from "@/data/job-requests/types/JobRequestClient";
import { JobRequestOrigin } from "@/data/job-requests/types/JobRequestOrigin";
import { JobRequestStatus } from "@/data/job-requests/types/JobRequestStatus";
import { LegalEntityShort } from "@/data/types/LegalEntityShort";
import { UserBase } from "@/data/users";

export const JobRequestShort = z
  .object({
    systemId: z.string(),
    title: z.string().nullish(),

    status: JobRequestStatus,
    origin: JobRequestOrigin,
    client: JobRequestClient.nullish(),

    legalEntityClient: LegalEntityShort.nullish(),
    administratorLegalEntityClient: LegalEntityShort.nullish(),

    hiringManager: UserBase.nullish(),

    promoteClient: z.boolean().nullish(),

    startDate: DateIsoString.nullish(),
    endDate: DateIsoString.nullish(),
  })
  .merge(DatabaseIdentity)
  .passthrough();

export type JobRequestShort = z.infer<typeof JobRequestShort>;
